export const CONTACT_INFORMATION = {
	name: 'Parafia Rzymsko – Katolicka pw. Najświętszego Serca Pana Jezusa w Mokrzyskach',
	adress: '32-800 Mokrzyska, Dobrego Pasterza 2, woj. Małopolskie',
	phone: '14-686-80-20',
	person: 'Ks. Tomasz Szewczyk',
	bank: 'PKO BP O/Brzesko',
	account: '34 1020 4984 0000 4702 0148 8246',
	nip: '8691708489',
	regon: '040064345',
	organist: 'Wojciech Oleksyk',
	organistPhone: '503-081-855',
};
